// Home.jsx - Backend email integration (NO EmailJS)
import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// REMOVED: import emailjs from 'emailjs-com';
import { motion, useInView } from 'framer-motion';

import { 
  FaGraduationCap, 
  FaPhone,
  FaUsers, 
  FaChartLine, 
  FaAward,
  FaStar,
  FaQuoteLeft,
  FaArrowRight,
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaUser,
  FaUserTie
} from 'react-icons/fa';
import './Home.css';

// REMOVED: emailjs.init('VOf9Q1CreblzdZh0b');

function Home() {
  const heroRef = React.useRef(null);
  const featuresRef = React.useRef(null);
  /*const statsRef = React.useRef(null);*/
  const testimonialsRef = React.useRef(null);
  const ctaRef = React.useRef(null);
 /* const servicesRef = React.useRef(null);
  const howItWorksRef = React.useRef(null);*/

  const isHeroInView = useInView(heroRef, { once: true });
  const isFeaturesInView = useInView(featuresRef, { once: true });
  const isTestimonialsInView = useInView(testimonialsRef, { once: true });
  const isCtaInView = useInView(ctaRef, { once: true });

  const [itemsPerSlide, setItemsPerSlide] = useState(3);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsPerSlide(1);
      } else if (window.innerWidth < 1024) {
        setItemsPerSlide(2);
      } else {
        setItemsPerSlide(3);
      }
    };
  
    handleResize();
    window.addEventListener("resize", handleResize);
  
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const features = [
    { icon: <FaGraduationCap />,
      title: 'Comprehensive Solutions',
      description: 'from mentoring and research guidance to test preparation and career planning.' },
    { icon: <FaUsers />,
      title: 'Trusted Expertise', 
      description: 'partnerships with leading education specialists and organizations.' },
    { icon: <FaChartLine />, 
      title: 'Global Reach', 
      description: 'access to opportunities and resources that open doors worldwide' },
    { icon: <FaAward />, 
      title: 'Complete Ecosystem', 
      description: 'With EngageHub, you do not just receive support, you gain a complete ecosystem for success.'
       }
  ];

  const navigate = useNavigate();
  const contactRef = React.useRef(null);
  const isInView = useInView(contactRef, { once: true });

  // State management - UPDATED: removed emailError, added submitError
  const [formData, setFormData] = useState({
    studentName: '',
    studentEmail: '',
    studentPhone: '',
    studentClass: '',
    subjects: '',
    preferredCountry: '',
    graduationYear: '',
    parentName: '',
    parentPhone: '',
    servicesRequired: '',
    address: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState(''); // CHANGED from emailError

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  // REMOVED: testEmailJS function - no longer needed

  // NEW: Backend API submission function (replaces EmailJS)
  const sendFormData = async (submissionData) => {
    try {
      console.log('Sending form data to backend...');
      
      // Send POST request to backend API
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(submissionData),
      });

      const data = await response.json();
      console.log('Backend response:', data);

      if (!response.ok) {
        throw new Error(data.message || 'Failed to submit form');
      }

      return { success: true, message: data.message };
    } catch (error) {
      console.error('Form submission error:', error);
      
      // Check if backend is running
      if (error.message.includes('Failed to fetch') || error.message.includes('Network')) {
        return { 
          success: false, 
          message: '⚠️ Cannot connect to server. Please make sure the backend is running (npm run server)' 
        };
      }
      
      return { 
        success: false, 
        message: error.message || 'Failed to submit form. Please try again.' 
      };
    }
  };

  // REMOVED: sendEmailToAdmin function - replaced with sendFormData

  // REMOVED: retryEmail function - no longer needed with backend

  // UPDATED: handleSubmit - now uses backend API
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError(''); // CHANGED from setEmailError
    setIsSubmitting(true);

    try {
      // Send form data to backend
      const result = await sendFormData(formData);

      if (result.success) {
        // Save to localStorage for admin dashboard
        saveSubmissionToStorage(formData);
        
        setSubmitSuccess(true);
        setIsSubmitting(false);

        // Redirect to success page after delay
        setTimeout(() => {
          navigate('/contact-success');
        }, 2000);
      } else {
        setSubmitError(result.message); // CHANGED from setEmailError
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error('Submission error:', error);
      setSubmitError('An unexpected error occurred. Please try again.'); // CHANGED from setEmailError
      setIsSubmitting(false);
    }
  };

  const saveSubmissionToStorage = (submissionData) => {
    const existingSubmissions = localStorage.getItem('contactSubmissions');
    let submissions = [];
    
    if (existingSubmissions) {
      submissions = JSON.parse(existingSubmissions);
    }
    
    const newSubmission = {
      id: Date.now(),
      timestamp: new Date().toISOString(),
      ...submissionData
    };
    
    submissions.unshift(newSubmission);
    localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
  };

  const testimonials = [
    { name: 'Parent of Grade 11 Student, Dubai',
       role: 'Parent',
        rating: 5, 
        text: "We were overwhelmed with the number of SAT prep options out there. Engagehub helped us connect with a trusted coaching provider within days. My daughter not only improved her SAT score by 200 points but also felt much more confident going into the exam. Engagehub made the whole process stress-free" },
    { name: 'Parent of Grade 12 Student, Abu Dhabi',
       role: 'Parent',
        rating: 5, 
        text: "Finding the right counsellor was always a challenge. Through Engagehub, we found a counsellor who perfectly understood my son's aspirations and guided him with college selection, essays, and applications. The personal attention and expertise made a world of difference. We are very grateful to Engagehub for bridging that gap" },
    { name: 'Parent of High School Junior, Sharjah', 
      role: 'Parent',
       rating: 5,
      text: "As parents, we wanted reliable and well-reviewed services for our child. Engagehub gave us peace of mind by connecting us to vetted SAT prep companies and counsellors. Instead of spending weeks researching, we got the right match in just a couple of conversations. Truly a one-stop solution" },
    { name: 'Parent of Student ',
       role: 'Parent',
        rating: 5,
        text: "Thanks to Engagehub, my daughter not only secured an excellent SAT score but also got admission counselling that helped her craft a strong application. She has now received offers from her top-choice universities. Engagehub was the perfect partner in this journey." },
    { name: 'Parent of Grade 12 Student, Abu Dhabi',
       role: 'Parent',
       rating: 5,
       text: "Engagehub made the daunting college admissions process so much easier. The counsellor we were matched with gave clear guidance on essays, applications, and university shortlisting. My daughter has already received offers from her top-choice schools. Couldn't have asked for a better experience." },
    { name: 'Parent of IBDP Year 1 Student, Dubai',
       role: 'Parent',
      rating: 5,
      text: "The IB Diploma can be overwhelming, especially with subjects like HL Math and Physics. Through Engagehub, we found an excellent tutor who made complex concepts clear and boosted my son's confidence. His grades have improved significantly" },
    { name: ' Parent of Grade 11 Student, Sharjah',
      role: 'Parent', 
      rating: 5,
      text: "My daughter needed help with AP Calculus and AP Biology. Engagehub quickly connected us to specialized tutors who understood the AP curriculum thoroughly. The sessions were structured, effective, and results-driven. She now feels fully prepared for her exams." },
    { name: 'Parent of High School Junior, UAE',
      role: 'Parent', 
      rating: 5,
      text: "As parents, we were concerned about choosing the right services for our child. Engagehub gave us a list of vetted SAT prep and tutoring providers, making the decision much easier. It was reassuring to know that every recommendation was trustworthy and proven" },
    { name: 'Parent of Accepted Student, Dubai',
      role: 'Parent',
      rating: 5, 
      text: "From SAT prep to IB tutoring and finally admissions counselling, Engagehub has been with us at every step of our child's journey. The ecosystem they provide is unmatched – reliable, efficient, and student-focused." },
      {name: "Parent of Grade 12 Student, Abu Dhabi",
        role:"Parent",
        rating: 5,
        text: "Instead of spending weeks researching tutors and counsellors, Engagehub helped us find the right match in just a couple of days. The entire process was smooth and stress-free, and our son is thriving academically and personally thanks to the support."}
  ];

  const totalSlides = Math.max(1, Math.ceil(testimonials.length / itemsPerSlide));
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const nextSlide = React.useCallback(() => {
    setCurrentSlide(prev => (prev + 1) % totalSlides);
  }, [totalSlides]);

  const prevSlide = React.useCallback(() => {
    setCurrentSlide(prev => (prev === 0 ? totalSlides - 1 : prev - 1));
  }, [totalSlides]);

  React.useEffect(() => {
    const id = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % totalSlides);
    }, 5000);
    return () => clearInterval(id);
  }, [totalSlides]);

  React.useEffect(() => {
    if (currentSlide >= totalSlides) {
      setCurrentSlide(0);
    }
  }, [totalSlides, currentSlide]);

  const renderStars = (rating) => {
    return Array.from({ length: rating }, (_, index) => (
      <FaStar key={index} className="star" />
    ));
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section ref={heroRef} className="hero">
        <div className="hero-background">
          <img src="./ClasroomStudents.jpg" alt="Hero Background" className="hero-bg-image" />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={isHeroInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <h1 className="hero-title">
              Empowering Students Through
              <span className="highlight"> Quality Education</span>
            </h1>
            <p className="hero-subtitle">
              Transform your academic journey with personalized tutoring, expert guidance, 
              and proven learning strategies designed for your success.
            </p>
            <div className="hero-buttons">
              <motion.button className="btn btn-primary" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <a href="./contact">Get Started Today</a>
                <FaArrowRight />
             </motion.button>
            </div> 
          </motion.div> 
        </div>
      </section>

      {/* Features Section */}
      <section ref={featuresRef} className="features section">
        <div className="container">
          <motion.div className="section-header" initial={{ opacity: 0, y: 30 }} animate={isFeaturesInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6 }}>
            <h2 className="section-title">Why Choose EngageHub?</h2>
            <p className="section-subtitle">
           At EngageHub, we are committed to delivering world-class educational guidance and support. Through our strategic collaborations we combine expertise, innovation, and global best practices to provide unmatched value to our students.
           <br/><p><b>Our students benefit from: </b></p>
            </p>
          </motion.div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <motion.div key={feature.title} className="feature-card" initial={{ opacity: 0, y: 30 }} animate={isFeaturesInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6, delay: index * 0.1 }} whileHover={{ y: -10 }}>
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section ref={testimonialsRef} className="testimonials section">
        <div className="container">
          <motion.div className="section-header" initial={{ opacity: 0, y: 30 }} animate={isTestimonialsInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6 }}>
            <h2 className="section-title">What Our Students & Parents Say</h2>
            <p className="section-subtitle">
              Real stories from real people who have experienced the EngageHub difference.
            </p>
          </motion.div>

          <div className="testimonials-carousel">
            <div className="carousel-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
              {Array.from({ length: totalSlides }, (_, groupIndex) => (
                <div className="testimonial-slide" key={groupIndex}>
                  <div className="cards-grid">
                    {testimonials.slice(groupIndex * itemsPerSlide, groupIndex * itemsPerSlide + itemsPerSlide).map((testimonial, index) => (
                      <motion.div key={testimonial.name + index} className="testimonial-card" initial={{ opacity: 0, y: 20 }} animate={isTestimonialsInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: index * 0.1 }}>
                        <div className="author-meta">
                          <h4 className="author-name">{testimonial.name}</h4>
                          <p className="author-role">{testimonial.role}</p>
                        </div>
                        <div className="testimonial-content">
                          <FaQuoteLeft className="quote-icon" />
                          <p className="testimonial-text">{testimonial.text}</p>
                        </div>
                        <div className="testimonial-bottom">
                          <div className="testimonial-rating">{renderStars(testimonial.rating)}</div>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="carousel-controls">
              <button className="carousel-btn prev" onClick={prevSlide}>‹</button>
              <button className="carousel-btn next" onClick={nextSlide}>›</button>
            </div>

            <div className="carousel-dots">
              {Array.from({ length: totalSlides }).map((_, index) => (
                <button key={index} className={`dot ${index === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(index)} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <motion.div 
        ref={contactRef}
        className="contact-form-section"
        initial={{ opacity: 0, x: 50 }}
        animate={isInView ? { opacity: 1, x: 0 } : {}}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <h2 className="section-title">Send us a Message</h2>
        <p className="section-subtitle">
          Fill out the form below and we'll get back to you within 24 hours.
        </p>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="studentName" className="form-label">
                <FaUser className="field-icon" />
                Student Name *
              </label>
              <input
                type="text"
                id="studentName"
                name="studentName"
                value={formData.studentName}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="Enter student's full name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="studentEmail" className="form-label">
                <FaEnvelope className="field-icon" />
                Student Email *
              </label>
              <input
                type="email"
                id="studentEmail"
                name="studentEmail"
                value={formData.studentEmail}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="Enter student's email address"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="studentPhone" className="form-label">
                <FaPhone className="contact-icon-phone" />
                Student Phone Number *
              </label>
              <input
                type="tel"
                id="studentPhone"
                name="studentPhone"
                value={formData.studentPhone}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="Enter student's phone number"
              />
            </div>

            <div className="form-group">
              <label htmlFor="studentClass" className="form-label">
                <FaGraduationCap className="field-icon" />
                Current Class/Grade *
              </label>
              <input
                type="text"
                id="studentClass"
                name="studentClass"
                value={formData.studentClass}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="e.g. 10 / High School / College Year 2"
              />
            </div>
          </div>
         
          <div className="form-row">
            <div className="form-group ">
              <label htmlFor="subjects" className="form-label">
                <FaGraduationCap className="field-icon" />
                Subjects of Interest *
              </label>
              <input
                type="text"
                id="subjects"
                name="subjects"
                value={formData.subjects || ""}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="e.g. Mathematics, Computer Science, Economics"
              />
            </div>

            <div className="form-group ">
              <label htmlFor="preferredCountry" className="form-label">
                <FaMapMarkerAlt className="field-icon" />
                Preferred Country 
              </label>
              <input
                type="text"
                id="preferredCountry"
                name="preferredCountry"
                value={formData.preferredCountry || ""}
                onChange={handleInputChange}
                className="form-input"
                placeholder="e.g. USA, UK, Canada, Germany"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="parentName" className="form-label">
                <FaUserTie className="field-icon" />
                Parent's Name *
              </label>
              <input
                type="text"
                id="parentName"
                name="parentName"
                value={formData.parentName}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="Enter parent's full name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="parentPhone" className="form-label">
                <FaPhone className="contact-icon-phone" />
                Parent's Phone Number *
              </label>
              <input
                type="tel"
                id="parentPhone"
                name="parentPhone"
                value={formData.parentPhone}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="Enter parent's phone number"
              />
            </div>
          </div>
       
          <div className="form-row">
            <div className="form-group ">
              <label htmlFor="graduationYear" className="form-label">
                <FaGraduationCap className="field-icon" />
                Year of Graduation
              </label>
              <input
                type="number"
                id="graduationYear"
                name="graduationYear"
                value={formData.graduationYear || ""}
                onChange={handleInputChange}
                className="form-input"
                placeholder="e.g. 2026"
                min="1900"
                max="2100"
              />
            </div>

                            <div className="form-group">
             <label htmlFor="servicesRequired" className="form-label">
               <FaUserTie className="field-icon" />
               Services Required *
             </label>
             <select
               id="servicesRequired"
               name="servicesRequired"
               value={formData.servicesRequired}
               onChange={handleInputChange}
               className="form-input"
               required
             >
               <option value="" disabled>Select a service</option>
               <option value="University Admissions Counseling">SAT</option>
               <option value="Career Guidance">ACT</option>
               <option value="Visa Assistance">GMAT</option>
               <option value="Scholarship Guidance">GRE</option>
               <option value="Test Preparation (SAT/IELTS/TOEFL)">AP COURCES</option>
               <option value="Application Essay Review">MYP</option>
               <option value="Application Essay Review">AMC</option>
               <option value="Application Essay Review">IGCSE</option>
               <option value="Application Essay Review">A LEVEL</option>
               <option value="Application Essay Review">IB</option>
               <option value="Application Essay Review">Admission Counselling</option>
               <option value="Application Essay Review">Research Assistance</option>
               <option value="Application Essay Review">Essay Editing Services</option>
               <option value="Other">Other</option>
             </select>
           </div>

           
            <div className="form-group ">
              <label htmlFor="address" className="form-label">
                <FaMapMarkerAlt className="field-icon" />
                Address *
              </label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="Enter your full address"
                rows="3"
              ></textarea>
            </div>
          </div>

          {/* UPDATED: Error message display */}
          {submitError && (
            <motion.div 
              className="error-message"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <p>{submitError}</p>
              {submitError.includes('backend') && (
                <p style={{ fontSize: '14px', marginTop: '10px' }}>
                  Run this command in a separate terminal:<br/>
                  <code style={{ background: '#f4f4f4', padding: '5px 10px', borderRadius: '4px', display: 'inline-block', marginTop: '5px' }}>
                    npm run server
                  </code>
                </p>
              )}
            </motion.div>
          )}

          <motion.button
            type="submit"
            className={`submit-btn ${isSubmitting ? 'submitting' : ''}`}
            disabled={isSubmitting}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </motion.button>

          {/* UPDATED: Success message */}
          {submitSuccess && (
            <motion.div 
              className="success-message"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <p>✅ Thank you! Your message has been sent successfully.</p>
              <p>📧 You will receive a confirmation email from Divya shortly.</p>
              <p>⏰ We'll get back to you within 24 hours.</p>
            </motion.div>
          )}
        </form>
      </motion.div>

      {/* CTA Section */}
      <section ref={ctaRef} className="cta section">
        <div className="container">
          <motion.div className="cta-content" initial={{ opacity: 0, y: 30 }} animate={isCtaInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6 }}>
            <h2 className="cta-title">Ready to Transform Your Academic Journey?</h2>
            <p className="cta-subtitle">
              Join hundreds of successful students who have achieved their goals with EngageHub.
            </p>
            <div className="hero-buttons">
              <motion.button className="btn btn-primary" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <a href="./contact">Start Your Success Story</a>
                <FaArrowRight />
             </motion.button>
              <div className="hero-partners">
              <p className="partners-title">Our Partners</p>
              <div className="partners-logos">
              <img src="./alokbansal.jpg" alt="Company 2" className="partner-logo" />
                <img src="./rootways.jpg" alt="Company 1" className="partner-logo" />
                {/*} <img src="./apguru.jpg" alt="Company 3" className="partner-logo" /> */}
              </div>
            </div>
            </div> 
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Home;